export default {
  status: "Status",
};
